<template>
  <div id="app">

    <nav class="navbar navbar-expand navbar-light bg-light">
      <router-link class="navbar-brand" to="#">RouterBoard RouterOS upgrader</router-link>
      <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarNav" aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
        <span class="navbar-toggler-icon"></span>
      </button>
      <div class="collapse navbar-collapse" id="navbarNav">
        <ul class="navbar-nav">
          <li class="nav-item">
            <router-link class="nav-link" to="#one-off">po jednom</router-link>
          </li>
        </ul>
      </div>
    </nav>
    <router-view/>
    <hr>
    <section id="footer">
      <a href="http://sojka-gitlab.hkfree.org/3765/mikrotik-update">authors</a>: {VojtaLhota,PeS,bkralik}@<a href="http://www.hkfree.org">hkfree.org</a>
    </section>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
hr {
  margin: 0.1em;
}
#footer {
  font-size: 50%;
  font-family: monospace;
  opacity: 0.5;
}
</style>



// WEBPACK FOOTER //
// src/App.vue